import React, { useEffect, useState } from "react";
import logo from "../../../assets/website/images/logo.png";
import "./PageLoader.css";

const PageLoader = () => {
  const [loading, setLoading] = useState(true);
  const [fading, setFading] = useState(false);

  const triggerLoader = () => {
    setLoading(true);
    setFading(false);
    
    // Simulate loading time, then fade out
    setTimeout(() => {
      setFading(true);
      setTimeout(() => {
        setLoading(false);
      }, 500); // fade out duration
    }, 1200); // display duration
  };

  useEffect(() => {
    // Initial load
    triggerLoader();

    // On visibility change (e.g. switching back to tab)
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        triggerLoader();
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  if (!loading && !fading) return null;

  return (
    <div className={`page-loader-overlay ${fading ? "fade-out" : ""}`}>
      <div className="page-loader-content">
        <img src={logo} alt="Logo" className="page-loader-logo" />
        <div className="page-loader-spinner">
          <div className="spinner-box"></div>
        </div>
        <div className="page-loader-text">Loading...</div>
      </div>
    </div>
  );
};

export default PageLoader;
